// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import vizzhyLogo from "../../Assests/VizzhyLogo/vizzhyLogo.svg";
// import "../../Styles/Header.scss";

// function Header() {
//   const location = useLocation();
//   const [isActiveIndex, setIsActiveIndex] = useState(1);
//   const [isHoveringContact, setIsHoveringContact] = useState(false);

//   const [isCollapsed, setIsCollapsed] = useState(true);
//   const closeNavbar = () => {
//     setIsCollapsed(true);

//     const navbarToggler = document.querySelector(".navbar-toggler");
//     if (navbarToggler && !isCollapsed) {
//       navbarToggler.click();
//     }
//   };

//   useEffect(() => {
//     switch (location.pathname) {
//       case "/about-us":
//         setIsActiveIndex(1);
//         break;
//       case "/product":
//       case "/LaboratoryServices":
//       case "/our-approach":
//         setIsActiveIndex(2);
//         break;
//       case "/team":
//         setIsActiveIndex(3);
//         break;
//       case "/careers":
//         setIsActiveIndex(5);
//         break;
//       case "/contact":
//         setIsActiveIndex(6);
//         break;
//       default:
//         setIsActiveIndex(1); // Default to 'About Us'
//         break;
//     }
//   }, [location.pathname]);

//   const toggleNavbar = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   return (
//     <div className="header-main heder-background d-flex p-3 w-100">
//       <div className="header-right-content w-100">
//         <nav className="navbar navbar-expand-lg navbar-light">
//           <div className="container-fluid text-center">
//             <div className="navbar-brand ">
//               <div className="ms-3 vizzhy-logo-main">
//                 <img
//                   src={vizzhyLogo}
//                   alt="Vizzhy Logo"
//                   className="vizzhy-logo"
//                 />
//               </div>
//             </div>
//             <button
//               className="navbar-toggler border-0"
//               type="button"
//               onClick={toggleNavbar}
//               data-bs-toggle="collapse"
//               data-bs-target="#navbarSupportedContent"
//               aria-controls="navbarSupportedContent"
//               aria-expanded="false"
//               aria-label="Toggle navigation"
//             >
//               {/* <span className="navbar-toggler-icon"></span> */}
//               {isCollapsed ? (
//                 <span className="navbar-toggler-icon"></span>
//               ) : (
//                 <button
//                   type="button"
//                   className="close border-0 fs-1"
//                   aria-label="Close"
//                 >
//                   <span aria-hidden="true">&times;</span>
//                 </button>
//               )}
//             </button>
//             <div
//               className="collapse navbar-collapse "
//               id="navbarSupportedContent"
//             >
//               <div className="d-flex justify-content-end mobile-navbar-collapse w-100 collapse-content">
//                 <div className="w-75">
//                   <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-evenly  text-nowrap">
//                     <li className="nav-item">
//                       <Link to="/about-us" className={`nav-link ${isActiveIndex === 1 ? "active-link" : ""}`}
//                         onClick={() => { setIsActiveIndex(1); closeNavbar(); }}>
//                         ABOUT US
//                       </Link>

//                     </li>
//                     <li className="nav-item dropdown">
//                       <a
//                         className={`nav-link dropdown-toggle our-platform-main  ${isActiveIndex === 2 ? "active-link" : ""
//                           }`}
//                         href="/our-platform"
//                         id="navbarDropdown"
//                         role="button"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         OUR PLATFORM
//                       </a>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="navbarDropdown"
//                       >
//                         <li className="our-approach-mobile">
//                           <Link to="/our-approach" className="dropdown-item" onClick={closeNavbar}>
//                             Our Approach
//                           </Link>
//                         </li>
//                         <li className="product-mobile">
//                           <Link to="/product" className="dropdown-item" onClick={closeNavbar}>
//                             Product
//                           </Link>
//                         </li>
//                         <li className="laboratoryservices-mobile" onClick={closeNavbar}>
//                           <Link
//                             to="/LaboratoryServices"
//                             className="dropdown-item"
//                           >
//                             Laboratory Services
//                           </Link>
//                         </li>
//                       </ul>
//                     </li>
//                     <li className="nav-item" onClick={closeNavbar}>
//                       <Link
//                         to="/team"
//                         className={`nav-link forgot-link ${isActiveIndex === 3 ? "active-link" : ""
//                           }`}
//                         onClick={() => setIsActiveIndex(3)}
//                       >
//                         TEAM
//                       </Link>
//                     </li>
//                     <li className="nav-item dropdown">
//                       <a
//                         className="nav-link dropdown-toggle"
//                         href="#/news"
//                         id="navbarDropdown"
//                         role="button"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         NEWS
//                       </a>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="navbarDropdown"
//                       >
//                         <li>
//                           <a className="dropdown-item" href="#/newComing">
//                             {/* Action */}
//                             Coming Soon                          </a>
//                         </li>
//                         {/* <li>
//                           <a className="dropdown-item" href="#">
//                             Another action
//                           </a>
//                         </li>
//                         <li>
//                           <hr className="dropdown-divider" />
//                         </li>
//                         <li>
//                           <a className="dropdown-item" href="#">
//                             Something else here
//                           </a>
//                         </li> */}
//                       </ul>
//                     </li>
//                     <li className="nav-item" onClick={closeNavbar}>
//                       <Link
//                         to="/careers"
//                         className={`nav-link forgot-link ${isActiveIndex === 5 ? "active-link" : ""
//                           }`}
//                         onClick={() => setIsActiveIndex(5)}
//                       >
//                         CAREERS
//                       </Link>
//                     </li>
//                     <li
//                       className={`nav-item ${isActiveIndex === 6 ? "active-header-contact" : ""
//                         }`}
//                       onMouseEnter={() => setIsHoveringContact(true)}
//                       onMouseLeave={() => setIsHoveringContact(false)}
//                       onClick={closeNavbar}
//                     >
//                       <div className="header-contact">
//                         <Link
//                           to="/contact"
//                           className={`rounded-5 px-5 py-2 nav-link forgot-link header-contact-us-main ${isActiveIndex === 6 ? "active-link primary-btn" : ""
//                             }`}
//                           onClick={() => setIsActiveIndex(6)}
//                         >
//                           {isHoveringContact || isActiveIndex === 6
//                             ? "Contact Us"
//                             : "Contact"}
//                         </Link>
//                       </div>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </nav>
//       </div>
//     </div>
//   );
// }

// export default Header;

import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom"; // Import NavLink
import vizzhyLogo from "../../Assests/VizzhyLogo/vizzhyLogo.svg";
import "../../Styles/Header.scss";

function Header() {
  const location = useLocation();

  const [isActiveIndex, setIsActiveIndex] = useState(1);
  const [isHoveringContact, setIsHoveringContact] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [showHeaderBg, setShowHeaderBg] = useState(true);

  const closeNavbar = () => {
    setIsCollapsed(true);
    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler && !isCollapsed) {
      navbarToggler.click();
    }
  };

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const path = location.pathname;

    // Update active tab index
    switch (path) {
      case "/about-us":
        setIsActiveIndex(1);
        break;
      case "/product":
      case "/LaboratoryServices":
      case "/our-approach":
      case "/products":
        setIsActiveIndex(2);
        break;
      case "/team":
        setIsActiveIndex(3);
        break;
      case "/event":
      case "/event/event-pitsburg":
      case "/event/event-pitmdplus":
        setIsActiveIndex(4);
        break;
      case "/careers":
        setIsActiveIndex(5);
        break;
      case "/contact":
        setIsActiveIndex(6);
        break;
      case "/technology":
        setIsActiveIndex(7);
        break;
      default:
        setIsActiveIndex(1);
        break;
    }

    // Background visibility logic
    if (path.startsWith("/event")) {
      setShowHeaderBg(true);
    } else {
      setShowHeaderBg(true); // Adjust as needed
    }
  }, [location.pathname]);

  return (
    <div className={`header-main ${showHeaderBg ? "heder-background" : ""} d-flex p-3 w-100`}>
      <div className="header-right-content w-100">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-fluid text-center">
            <div className="navbar-brand">
              <div className="ms-3 vizzhy-logo-main">
                <img src={vizzhyLogo} alt="Vizzhy Logo" className="vizzhy-logo" />
              </div>
            </div>
            <button
              className="navbar-toggler border-0"
              type="button"
              onClick={toggleNavbar}
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              {isCollapsed ? (
                <span className="navbar-toggler-icon"></span>
              ) : (
                <button type="button" className="close border-0 fs-1" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              )}
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <div className="d-flex justify-content-end mobile-navbar-collapse w-100 collapse-content">
                <div className="w-75">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-evenly text-nowrap">
                    <li className="nav-item">
                      <Link
                        to="/about-us"
                        className={`nav-link ${isActiveIndex === 1 ? "active-link" : ""}`}
                        onClick={() => {
                          setIsActiveIndex(1);
                          closeNavbar();
                        }}
                      >
                        ABOUT US
                      </Link>
                    </li>

                    <li className="nav-item dropdown">
                      <a
                        className={`nav-link dropdown-toggle our-platform-main ${isActiveIndex === 2 ? "active-link" : ""}`}
                        href="/our-platform"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        OUR PLATFORM
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li className="our-approach-mobile">
                          <Link to="/our-approach" className="dropdown-item" onClick={closeNavbar}>
                            Our Approach
                          </Link>
                        </li>
                        <li className="product-mobile">
                          <Link to="/product" className="dropdown-item" onClick={closeNavbar}>
                            Vizzhy App
                          </Link>
                        </li>
                        <li className="laboratoryservices-mobile" onClick={closeNavbar}>
                          <Link to="/LaboratoryServices" className="dropdown-item">
                            Laboratory Services
                          </Link>
                        </li>
                        <li className="laboratoryservices-mobile" onClick={closeNavbar}>
                          <Link to="/products" className="dropdown-item">
                            Products
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item" onClick={closeNavbar}>
                      <Link
                        to="/team"
                        className={`nav-link forgot-link ${isActiveIndex === 3 ? "active-link" : ""}`}
                        onClick={() => setIsActiveIndex(3)}
                      >
                        TEAM
                      </Link>
                    </li>

                    {/* Use NavLink for Events to handle subroutes */}
                    <li className="nav-item" onClick={closeNavbar}>
                      <NavLink
                        to="/event"
                        className={({ isActive }) =>
                          `nav-link forgot-link ${isActive || isActiveIndex === 4 ? "active-link" : ""}`
                        }
                        onClick={() => setIsActiveIndex(4)}
                        // Custom logic to mark as active for /event/* routes
                        isActive={(match, location) => {
                          return location.pathname.startsWith("/event") || isActiveIndex === 4;
                        }}
                      >
                        EVENTS
                      </NavLink>
                    </li>
                    <li className="nav-item" onClick={closeNavbar}>
                      <NavLink
                        to="/technology"
                        className={({ isActive }) =>
                          `nav-link forgot-link ${isActive || isActiveIndex === 7 ? "active-link" : ""}`
                        }
                        onClick={() => setIsActiveIndex(7)}
                        // Custom logic to mark as active for /event/* routes
                        isActive={(match, location) => {
                          return location.pathname.startsWith("/technology") || isActiveIndex === 7;
                        }}
                      >
                        TECHNOLOGY
                      </NavLink>
                    </li>

                    <li className="nav-item" onClick={closeNavbar}>
                      <Link
                        to="/careers"
                        className={`nav-link forgot-link ${isActiveIndex === 5 ? "active-link" : ""}`}
                        onClick={() => setIsActiveIndex(5)}
                      >
                        CAREERS
                      </Link>
                    </li>

                    <li
                      className={`nav-item ${isActiveIndex === 6 ? "active-header-contact" : ""}`}
                      onMouseEnter={() => setIsHoveringContact(true)}
                      onMouseLeave={() => setIsHoveringContact(false)}
                      onClick={closeNavbar}
                    >
                      <div className="header-contact">
                        <Link
                          to="/contact"
                          className={`rounded-5 px-5 py-2 nav-link forgot-link header-contact-us-main ${isActiveIndex === 6 ? "active-link primary-btn" : ""}`}
                          onClick={() => setIsActiveIndex(6)}
                        >
                          {isHoveringContact || isActiveIndex === 6 ? "Contact Us" : "Contact"}
                        </Link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;